export const SmoothScroll = (offset = 0) => {
  const scrollToTarget = (element) => {
    console.log(`scrollTo`,element);

    const rect = element.getBoundingClientRect();
    const absoluteTop = window.pageYOffset + rect.top;
    const targetPosition = absoluteTop + offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  };

  const hashScroll = () => {
    const hash = location.hash.replace('#', '');

    if (!hash) return;
    const target = document.getElementById(hash);
    if (target) {
      scrollTo(0, 0); // 初期位置を打ち消す（Safari対策）
      setTimeout(() => {
        scrollToTarget(target);
      }, 0);
    }
  };

  const links = document.querySelectorAll('a[href*="#"]');
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const hash = href.split('#')[1];


      if (!hash) return;
      const target = document.querySelector(`[id*="${hash}"]`);
      if (target) {
        e.preventDefault();
        history.pushState(null, null, `#${hash}`);
        scrollToTarget(target);
      }
    });
  });

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('load', () => {
    hashScroll();
    console.log(`SmoothScroll loaded!`);

  });
};
